<template>
  <el-select
    v-model="dataValue"
    placeholder="请选择触发条件"
    @change="onChage">
    <el-option
      label="全部条件"
      :value="null">
    </el-option>
    <el-option
      v-for="item in list"
      :key="item.key"
      :label="item.value"
      :value="item.key">
    </el-option>
  </el-select>
</template>
<script>
export default {
  name: 'NotifySceneSelect',
  props: {
    value: { type: [Number, null], default: null }
  },
  data() {
    return {
      list: [
        { key: 1, value: '卖家超时未发货' },
        { key: 2, value: '超时未支付验货费' },
        { key: 3, value: '超时未确认验货报告' }
      ]
    }
  },
  computed: {
    dataValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    onChage() { }
  }
}
</script>
